/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 15:12:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-05 11:03:59
 */
import common from "../../common/common";
import { routerFor, routerForUrl } from "../../common/other";
import configData from "../../config/config";
import recursionRouter from "../../router/add-router";
import router from "../../router/index";
import { getPermission } from "../../api/api-basic";
// import { getOprInfo } from "../../api/api-operation-service";
import { objAny } from "../../common/common-interface";
import menuListData from "../../router/menu";
const state = {
  isLogin: false,
  winOnresize: false, // 窗口变化
  isGetRouter: false, // 是否初始化路由
  keepAliveList: [], //缓存的路由
  goRouter: [], // 经过的路由 tag用到
  toData: {}, // 当前的路由
  routerList: [],
  routerMainIndex: {}, // 当前路由的主页面（就是菜单路由，用来区别当前是菜单路由还是菜单的子级路由）
  userInfo: {}, // 用户信息
  menuIndex: 0, // 当前头部的大菜单
  menuList: [], // 菜单列表
  pageLoading: false, // 页面加载
  operInfo: {} // 运营商信息
};

const getters = {};

const mutations = {
  /**
   * 是否登录
   * @param state
   * @param status 状态
   */
  SET_ISLOGIN(state: objAny, status: boolean): void {
    state.isLogin = status;
  },

  /**
   * 窗口变化是改变
   * @param state
   */
  SET_WINONRESIZE(state: objAny) {
    state.winOnresize = !state.winOnresize;
  },

  /**
   * 动态添加路由
   * @param {*} state
   * @param {object[]} list 后台返回的菜单
   */
  SET_ROUTERLIST(state: objAny, list: object[]) {
    const routerList: any = recursionRouter(list) // eslint-disable-line
    //动态添加路由
    router.addRoutes(routerList);
    state.routerList = routerList;
  },

  /**
   * 路由变化时执行,保存经过的路由,最多5个,用在tag标签和缓存路由
   * @param {*} state
   * @param {objAny} data 经过路由的数据
   */
  SET_GOROUTER(state: objAny, data: objAny) {
    // if (data.mainIdex) {
    //   if (state.keepAliveList.indexOf(data.componentsName) == -1) {
    //     state.keepAliveList.push(data.componentsName);
    //   }
    //   if (state.keepAliveList.length > 4) {
    //     state.keepAliveList.splice(0, 1);
    //   }

    // }
    if (data.mainIdex) {
      let isPush = true;
      state.goRouter.map((item: objAny) => {
        if (item.url == data.url) {
          isPush = false;
        }
      });
      if (isPush) {
        if (state.goRouter.length >= 6) {
          state.goRouter.splice(0, 1);
        }
        state.goRouter.push(data);
      }
    }
  },

  /**
   *  删除路由 tag
   * @param {*} state
   * @param {number} index
   */
  UP_GOROUTER(state: objAny, index: number) {
    const list = state.goRouter;
    list.splice(index, 1);
    state.goRouter = list;
    const keepAliveList: object[] = [];
    list.map((item: objAny) => {
      keepAliveList.push(item.componentsName);
    });
    state.keepAliveList = keepAliveList;
  },
  /**
   * 当前的路由
   * @param {*} state
   * @param {objAny} data
   */
  SET_TODATE(state: objAny, data: objAny) {
    state.toData = data;
  },
  /*
   * 是否经过路由初始化
   * @param {*} state
   * @param {boolean} status
   */
  SET_ISGETROUTER(state: objAny, status: boolean) {
    state.isGetRouter = status;
  },
  /**
   * 登录信息
   * @param {*} state
   * @param {objAny} data
   */
  SET_USERINFO(state: objAny, data: objAny) {
    state.userInfo = data;
  },
  /**
   * 登录信息
   * @param {*} state
   * @param {objAny} data
   */
  SET_MENULIST(state: objAny, list: object[]) {
    state.menuList = routerFor(list);
  },
  SET_PAGELOADING(state: objAny, status: boolean) {
    state.pageLoading = status;
  },
  SET_OPERINFO(state: objAny, data: objAny) {
    state.operInfo = data;
  }
};
const forMenuChild = function(list: object[]): string {
  let str = "";
  list.map((item: objAny, index: number) => {
    if (index == 0) {
      if (item.children && item.children.length > 0) {
        str = forMenuChild(item.children);
      } else {
        str = item.url;
      }
    }
  });
  return str;
};
const actions = {
  /**
   * 路由初始化
   * @param {*} { commit, state }
   * @param {objAny} obj
   */
  async getRouter({ commit }: objAny, obj: objAny) {
    const loginData: objAny = common.get("loginData");
    const win: objAny = window;
    if (loginData) {
      state.isGetRouter = true;
      commit("SET_USERINFO", loginData);
      // commit("SET_MENULIST", menuListData);
      // commit("SET_ROUTERLIST", menuListData);

      let toUrl: string = obj.to.fullPath;

      const retMemu = await getPermission({ roleId: loginData.rolePkId });

      if (retMemu.status === configData.apiStatus) {
        let listObj: objAny = {};
        retMemu.data.map((item: objAny) => {
          if (item.modulePkId == configData.sysModulePkId) {
            listObj = item;
          }
        });

        const data: objAny[] = listObj.children ? listObj.children : [];

        // 登录进来，首页还没有做的时候
        commit("SET_MENULIST", data);
        commit("SET_ROUTERLIST", data);
        if (toUrl == "/") {
          const itemDataUrl = routerForUrl(data);
          if (itemDataUrl) {
            toUrl = itemDataUrl.url;
          } else {
            toUrl = forMenuChild(data);
          }
        }
      }
      commit("SET_ISLOGIN", true);

      // const ret = await getOprInfo({});
      // if (ret.status === configData.apiStatus) {
      //   // operInfo
      //   const info = ret.data[0] || {};
      //   commit("SET_OPERINFO", info);
      // }
      obj.next &&
        obj.next({
          path: toUrl
        });
    } else {
      commit("SET_ISGETROUTER", false);
      commit("SET_ISLOGIN", false);

      if (configData.loginUrl && configData.loginUrl != "") {
        win.location.href = configData.loginUrl;
      } else {
        obj.next({
          path: "/login"
        });
      }
    }
    win.onresize = common.debounce(() => {
      commit("SET_WINONRESIZE", true);
    }, 200);
  }
  // async getOprInfo({ commit }: objAny) {
  //   const ret = await getOprInfo({});
  //   if (ret.status === configData.apiStatus) {
  //     commit("SET_OPERINFO", ret.data[0]);
  //   }
  // }
};

export default {
  state,
  mutations,
  actions,
  getters
};
